<div if.bind="account.welcomeOpen" class="modal-overlay" click.trigger="account.dismissWelcome()">
  <div class="login-modal welcome-modal" click.trigger="$event.stopPropagation()">
    <h3 class="welcome-modal__title">Never miss a toy drop.</h3>
    <p class="welcome-modal__subtitle">
      Toy Calendar tracks upcoming releases from across the web so you always know what&rsquo;s
      coming &mdash; and when it lands.
    </p>

    <ul class="welcome-modal__benefits">
      <li class="welcome-benefit">
        <span class="welcome-benefit__icon" aria-hidden="true">&#128197;</span>
        <span class="welcome-benefit__text">
          <span class="welcome-benefit__label">Every release in one calendar</span>
          <span class="welcome-benefit__hint">Browse upcoming drops by day, all in one place.</span>
        </span>
      </li>
      <li class="welcome-benefit">
        <span class="welcome-benefit__icon" aria-hidden="true">&#128276;</span>
        <span class="welcome-benefit__text">
          <span class="welcome-benefit__label">Free email alerts</span>
          <span class="welcome-benefit__hint">Save a search and we&rsquo;ll email you when new matches appear.</span>
        </span>
      </li>
      <li class="welcome-benefit">
        <span class="welcome-benefit__icon" aria-hidden="true">&#11088;</span>
        <span class="welcome-benefit__text">
          <span class="welcome-benefit__label">Track &amp; get reminders</span>
          <span class="welcome-benefit__hint">Follow the toys you want and get a nudge when they&rsquo;re available.</span>
        </span>
      </li>
    </ul>

    <div class="login-actions welcome-modal__actions">
      <button type="button" class="login-btn login-btn--primary welcome-modal__cta" click.trigger="account.signUpFromWelcome()">
        Create free account
      </button>
      <p class="welcome-modal__reassure">It&rsquo;s completely free. Takes about 10 seconds.</p>
      <button type="button" class="welcome-modal__later" click.trigger="account.dismissWelcome()">
        Maybe later &mdash; just browsing
      </button>
    </div>
  </div>
</div>
